import { useState } from "react";
import ChangeInformationModal from "../components/modal/change-information";
import { useUser } from "../context/UserContext";
import AccountLayout from "../layouts/AccountLayout"
import './../styles/change-information.css';

export const ChangeInformation = () => {
    const { user, setUser } = useUser();
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <AccountLayout title={'Thay đổi thông tin của bạn'}>
            <ChangeInformationModal
                user={user}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                setUser={setUser}
            />
            <div className="change-information-container">
                <h3>Cập nhật thông tin</h3>
                <div className="user-information-container">
                    <div className="avatar-container">
                        <p>Ảnh đại diện</p>
                        <img className="user-avatar-img" src={user?.profileImg} alt="Profile Image"></img>
                    </div>
                    <div className="information-details-container">
                        <div className="user-details-header-title">
                            <p className="details-header-text">Thông tin chung</p>
                            <button onClick={() => setIsModalOpen(true)} className="edit-user-information">Sửa thông tin</button>
                        </div>
                        <div className="details-user">
                            <div className="details-container">
                                <p className="detail-key">Họ và tên:</p>
                                <span className="detail-value">{user?.fullName || "Chưa có"}</span>
                            </div>
                            <div className="details-container">
                                <p className="detail-key">Tên đăng nhập:</p>
                                <span className="detail-value">{user?.username}</span>
                            </div>

                            <div className="details-container">
                                <p className="detail-key">Email:</p>
                                <span className="detail-value">{user?.email}</span>
                            </div>

                            <div className="details-container">
                                <p className="detail-key">Số điện thoại:</p>
                                <span className="detail-value">{user?.phone || "Chưa có"}</span>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </div>
        </AccountLayout>
    )
}